import React from 'react'
import Card from '../../core/Card'
import { reduxForm, submit, hasSubmitSucceeded } from 'redux-form'
import { connect } from 'react-redux'
import { push, goBack } from 'react-router-redux'
import FavoriteTrip from './FavoriteTrip'
import { message } from 'antd';
import { addFavoriteTrip } from './actions'

const mapStateToProps = ({ models: { places, user } }) => {
  return {
    title: 'New Favorite Trip',
    buttonTitle: 'Save',
    places: [
      {token_id:'', name: 'Anywhere', street: 'Includes all locations', icon_name: 'Marker'}
    ].concat(Object.values(places.byId)),
    purposes: [
      ...user.income_sources,
      'Personal',
      'Medical',
      'Charity',
      'Moving',
      'Commute'
    ],
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    onRemoteSubmit: () => dispatch(submit('NewFavoriteTrip')),
  }
}

const New = connect(mapStateToProps, mapDispatchToProps)(FavoriteTrip)

export default reduxForm({
  form: 'NewFavoriteTrip',  // a unique identifier for this form
  onSubmit: (trip, dispatch, ownProps)=> dispatch(addFavoriteTrip(trip))
    .then(()=>message.success('Favorite Trip added successfully.', 4)),
})(New)



// WEBPACK FOOTER //
// ./src/account/favorite-trips/New.js